module.exports = __webpack_public_path__ + "static/john1-61320f2c83f60eb8176b9f60edf1fced.jpg";